<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 6" :key="i" :style="{ backgroundColor: bg }">
      <!--  <shSkeleton bg="#e4e4e4" width="195px" height="120px" animated /> -->
      <shSkeleton bg="#e4e4e4" width="395px" height="25px" animated />
      <!-- <shSkeleton bg="#e4e4e4" width="90px" height="24px" animated /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  /*  width: 400px;
  height: 185px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center; */
  .item {
    width: 395px;
    padding-top: 5px;
    margin-left: 1.25px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 16px auto 0;
    }
  }
}
</style>
